export default class Person {
	constructor() {
		this.firstName = null;
		this.surname = null;
		this.isContact = false;
	}
}
